export default {
  title: {
    id: 'insurance_policy_details_payment_details_title',
    defaultMessage: 'Payment details',
  },
  nextPayment: {
    id: 'insurance_policy_details_payment_details_next_payment',
    defaultMessage: 'Next payment',
  },
  nextPaymentDate: {
    id: 'insurance_policy_details_payment_details_next_payment_date',
    defaultMessage: 'on {date}',
  },
  totalDue: {
    id: 'insurance_policy_details_payment_details_total_due',
    defaultMessage: 'Total due today',
  },
  paymentFailedInfo: {
    id: 'insurance_policy_details_payment_details_payment_failed_info',
    defaultMessage:
      'The last few payments haven’t gone through so you’re not currently covered. To stay protected, catch up on missed payments. Then, you’ll continue to be charged the monthly amount as usual.',
  },
  updatePaymentMethod: {
    id: 'insurance_policy_details_payment_details_update_payment_method',
    defaultMessage: 'Update payment method',
  },
}
